/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export default function propsTransformer({additionalProps, ...props}) {
	const searchParams = new URLSearchParams(window.location.search);

	return {
		...props,
		hrefConstructor: (page) => `#${page}`,
		onPageChange: (pageNumber) => {
			searchParams.set(
				`page_number_${additionalProps.collectionId}`,
				pageNumber
			);

			window.location.search = searchParams;
		},
	};
}
